import Vue from "vue"
import Vuetify from "vuetify/lib/framework"
import AspenIcons from "../assets/aspen/icons/aspeniconsprite"
import "@mdi/font/css/materialdesignicons.css"

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        defaultTheme: "aspenDental",
        themes: {
            light: {
                primary: "#002855",
                secondary: "#004BB9",
                accent: "#CF2A2A",
                info: "#B9DEFA",
                success: "#A4E2B4",
                warning: "#FFEC9F",
                anchor: "#004BB9",
            },
        },
    },
    icons: {
        iconfont: "mdi", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg',
        values: AspenIcons,
        // <v-icon></v-icon>
    },
})
